import { setLocale } from 'yup'
import * as yup from 'yup'

// Regex email robuste (RFC 5322 simplifiée)
// Valide la structure locale@domaine avec extensions de domaine valides
export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

/**
 * Crée un schéma d'email avec un message d'erreur personnalisé pour le champ requis
 */
export const createEmailSchema = (requiredMessage = 'L\'email est requis') => {
  return yup.string()
    .required(requiredMessage)
    .matches(emailRegex, 'Veuillez entrer une adresse email valide')
    .max(255, 'L\'email ne peut pas dépasser 255 caractères')
}

export function initYupLocale() {
  setLocale({
    mixed: {
      default: 'Champ invalide',
      required: 'Ce champ est obligatoire',
      oneOf: ({ values }) => {
        if (!Array.isArray(values)) {
          return 'La valeur doit être une des suivantes :';
        }
        return `La valeur doit être une des suivantes : ${values.join(', ')}`;
      },
      notOneOf: ({ values }) => `La valeur ne doit pas être une des suivantes : ${values.join(', ')}`,
      defined: 'Ce champ doit être défini',
    },
    string: {
      length: ({ length }) => `Ce champ doit contenir exactement ${length} caractères`,
      min: ({ min }) => `Ce champ doit contenir au moins ${min} caractères`,
      max: ({ max }) => `Ce champ doit contenir au maximum ${max} caractères`,
      matches: 'Le format est invalide',
      email: 'Ce champ doit être un email valide',
      url: 'Ce champ doit être une URL valide',
      uuid: 'Ce champ doit être un UUID valide',
      trim: 'Ce champ ne doit pas contenir d’espaces au début ou à la fin',
      lowercase: 'Ce champ doit être en minuscules',
      uppercase: 'Ce champ doit être en majuscules',
    },
    number: {
      min: ({ min }) => `La valeur doit être supérieure ou égale à ${min}`,
      max: ({ max }) => `La valeur doit être inférieure ou égale à ${max}`,
      lessThan: ({ less }) => `La valeur doit être inférieure à ${less}`,
      moreThan: ({ more }) => `La valeur doit être supérieure à ${more}`,
      positive: 'La valeur doit être positive',
      negative: 'La valeur doit être négative',
      integer: 'La valeur doit être un entier',
    },
    date: {
      min: ({ min }) => `La date doit être postérieure à ${min}`,
      max: ({ max }) => `La date doit être antérieure à ${max}`,
    },
    boolean: {
      isValue: 'La valeur doit être vraie ou fausse',
    },
    array: {},
    object: {},
    tuple: {},
  })
}
